import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import Settings from './Settings';
import Auth from './Auth';
import forgotPassword from './forgotPassword';
import patients from "./patients";
import kpi from "./kpi";
import user from "./user";
import home from "./home";
import realtime from "./realtime";
import device_config_reducer from './device_config';
import datacenter_reducer from './Data_Center_Reducer';
export default (history) => combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    forgotPassword,
    patients,
    kpi,
    user,
    home,
    realtime,
    device_config: device_config_reducer,
    dataCenter: datacenter_reducer
});
